import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./styles.css";
import { faCalendarAlt, faSignOutAlt, faUser, faUsersCog } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import Logo from "../../images/logo.png";

const NavigationMenu = () => {
  const navigate = useNavigate();
  return (
    <div className="navigation__menu">
      <div className="navigation__logo">
        <img src="https://petros-global.com/uploads/logo/logo.png" />
      </div>
      <div className="navigation__list">
        <div className="navigation__list-item active">
          <FontAwesomeIcon icon={faCalendarAlt} />
        </div>
        {/* <div className="navigation__list-item">
          <FontAwesomeIcon icon={faUsersCog} />
        </div> */}
        <div className="navigation__list-item" onClick={() => {
          localStorage.removeItem("user-data");
          navigate("/ems/login/");
        }}>
          <FontAwesomeIcon icon={faSignOutAlt} />
        </div>
      </div>
    </div>
  );
};

export default NavigationMenu;